<template>







  <section>
       <!-- Content Header (Page header) -->
       <section class="content-header">
          <h1>
             PAPELETAS
             <small>Percy</small>
          </h1>
          <ol class="breadcrumb">
             <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
             <li class="active">Papeletas</li>
          </ol>
       </section>
       <!-- Main content -->
       <section class="content">
          <div class="row">
          <!-- left column -->
          <div class="col-md-12">
            <div class="box box-primary">
              <div class="content table-responsive table-full-width" >
                 <table class="table table-condensed">
                    <thead>
                       <tr class="active">
                          <th>AREA</th>
                          <th>TRABAJADOR</th>
                          <th>RESPONSABLE</th>
                          <th>ESTADO</th>
                          <th>Acción</th>
                       </tr>
                    </thead>
                    <tbody>
                       <tr v-for="algo in alg">
                          <td data-title="CÓDIGO">1</td>
                          <td data-title="NÚMERO">Dakota Rice</td>
                          <td data-title="DEMANDANTE">$36,738</td>
                          <td data-title="DEMANDADO">Niger</td>
                          <td data-title="VER">
                            <router-link to="/papeletas/1">
                              <span rel="tooltip" title="Ver" data-state="primary" data-placement="right" class="fa fa-search btn btn-success"></span>
                            </router-link>
                            <router-link to="/papeletas/1/editar">
                              <span rel="tooltip" title="Editar" data-state="primary" data-placement="right" class="fa fa-pencil btn btn-facebook"></span>
                            </router-link>

                          </td>
                       </tr>
                    </tbody>
                 </table>
              </div>



            </div>
          </div>
        </div>
       </section>
    </section>




</template>

<script>

  import config from '../../config';
import { mapMutations } from 'vuex'


export default {
  name : 'PapeletasAprobador',
  data() {
    return {
      papeletas : [],
    }
  },
  mounted(){
      console.log('Iniciando');
      $(".table").DataTable();

      console.log('sublime graciaaaa ', mapMutations)

      this.comenzando();

    


  },

  methods : {
    ...mapMutations([
      'consultar_papeletas'
    ]),
    comenzando (){
      console.log('enviado')

      this.consultar_papeletas('xd')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasAprobador.vue